export const GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT = 'GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT'
export const GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_SUCCESS = 'GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_SUCCESS'
export const GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_FAILED = 'GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_FAILED'

export const CLEAR_ENQUIRY_VIEWING_PERFORMANCE_REPORT = 'CLEAR_ENQUIRY_VIEWING_PERFORMANCE_REPORT'
